import { Outlet } from "react-router-dom";
import { ReturnList } from "./ReturnList";
import { ReturnDetails } from "./ReturnDetails";

export const returnsRoutes = [
    {
        path: "returns",
        element: Outlet,
        children: [
            {
                path: "",
                element: ReturnList,
            },
            {
                path: "view/:id",
                element: ReturnDetails,
            },
        ],
    },
];